import React from 'react';
import { ApiTokenSummary } from '../types';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';

interface Props {
  tokens: ApiTokenSummary[];
  deletingIds: string[];
  onDelete: (id: string) => void;  
}

const ApiTokenList: React.FC<Props> = ({ tokens, deletingIds, onDelete }) => {
  if (!tokens.length) {
    return <div>No API tokens yet.</div>;
  }

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Token</th>
          <th>Created Date</th>
          <th>Expiry Date</th>
          {/* <th>Last Used</th>           */}
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {tokens.map(t => {
          const deleting = deletingIds.includes(t.id);


          const localExpires = new Date(t.expires);
          const expires = new Date(localExpires.getTime() + localExpires.getTimezoneOffset() * 60000);


          return (
            <tr key={t.id}>
              <td>{t.name}</td>
              <td>{t.partialToken}</td>
              <td>{new Date(t.created).toDateString()}</td>
              <td className={`${expires.getTime() < new Date().getTime() ? 'red-text' : ''}`}>
                {expires.toLocaleDateString()}&nbsp;(<Moment fromNow>{expires}</Moment>)
              </td>
              {/* <td>{t.lastUsedUtc ? new Date(t.lastUsedUtc).toLocaleString() : '-'}</td>               */}              
              <td>
                <Link to={`/user/api-tokens/update/${t.id}`} className="button">Update</Link>
              </td>
              <td>
                <Link to={`/user/api-tokens/renew/${t.id}`} className="button">Renew</Link>                
              </td>
              <td>
                <button className="button" disabled={deleting} onClick={() => onDelete(t.id)}>{deleting ? 'Deleting...' : 'Delete'}</button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ApiTokenList;
